/*global vdomVirtualize, virtualDom, MobileDetect, objectHash, _ */
import { ACTIONS } from "./_actions";
import { store, deepLinkMap } from "./_config-store";

export const GTMLogger = store => next => (action) => {
	if (window.dataLayer) {
		let state = store.getState();
		switch (action.type) {
			case ACTIONS.FOCUSED_OPTION_CHANGE: {
				if (action.cat && action.option) {
					window.dataLayer.push({
						event: "config_option_change",
						data: {
							truckCab: convertName(state.truckCab),
							view: state.view,
							cat: action.cat,
							option: action.option
						}
					});
				}
				break;
			}
			case ACTIONS.OPTION_SELECT: {
				window.dataLayer.push({
					event: "config_selection",
					data: {
						truckCab: convertName(state.truckCab),
						view: state.view,
						cat: action.cat,
						option: action.option
					}
				});
				break;
			}
			case ACTIONS.CAB_CHANGE: {
				window.dataLayer.push({
					event: "cab_change",
					data: {
						truckCab: convertName(action.data.truckCab)
					}
				});
				break;
			}
			case ACTIONS.QUOTE_SUBMITTED: {
				window.dataLayer.push({
					event: "configurator_request_quote",
					data: {
						truckCab: convertName(state.truckCab),
						hash: action.hash,
						dealerCode: action.dealer && action.dealer.Code ? action.dealer.Code : "international",
						application: action.application,
						section: state.previousViewOption,
						exterior: JSON.stringify(state.exteriorBuildSettings),
						interior: JSON.stringify(state.interiorBuildSettings),
						misc: JSON.stringify(state.miscBuildSettings),
					}
				});
				break;
			}
		}
	}
	return next(action);
};

export function isMobileDevice() {
	let mobile = new MobileDetect(window.navigator.userAgent);
	return !!(mobile.mobile() || mobile.tablet());
}

export function getVNodeFromHMTL(html) {
	return convertHTML(html);
}

export function setupMixins() {
	_.mixin({
		deepPluck: (obj, path) => {
			if (_.isString(path)) {
				path = path.split(".");
			}
			return _.reduce(path, function pluck(ret, ident) {
				if (ident === "*") {
					for (var key in ret) {
						if (ret.hasOwnProperty(key)) {
							return ret[key];
						}
					}
				}
				return ret[ident];
			}, obj);
		}
	});
}

setupMixins();

export function delegate(wrapper, selector, eventNames) {
	return Rx.Observable.from(eventNames.split(" ")).mergeMap(eventName => {
		return Rx.Observable.fromEvent(
			wrapper,
			eventName.replace(/\s/g, ""),
			function (e) {
				return { event: e, delegate: e.target.closest(selector) };
			});
	}).filter(function (x) {
		return x.delegate !== null;
	});
}

export function padNumber(num, digits, trim) {
	var neg = '';
	if (num < 0) {
		neg = '-';
		num = -num;
	}
	num = '' + num;
	while (num.length < digits) num = '0' + num;
	if (trim)
		num = num.substr(num.length - digits);
	return neg + num;
}

export function emitCustomEvent(eventName, eventPayload) {
	var event = new CustomEvent(eventName, {
		'view': window,
		'bubbles': true,
		'cancelable': true,
		'detail': eventPayload
	});
	document.body.dispatchEvent(event);
}

export function launchConfigurator() {
	$("body").addClass("configurator-open");
	$("#configurator").addClass("open");
	store.dispatch({
		type: ACTIONS.INIT_CONFIGURATOR
	});
}

export function decodeHtml(html) {
	var txt = document.createElement("textarea");
	txt.innerHTML = html;
	return txt.value;
}

export function getOptionsDetails(details, model, cab, key) {
	return _.at(details, '["' + model + '"]["' + _.snakeCase(cab) + '"]["' + key + '"]')[0] || _.at(details, '["' + model + '"]["*"]["' + key + '"]')[0];
}

export function convertName(s, spaceReplacer = "_") {
	return s.toLowerCase().replace(/"/g, '').replace(/\s/g, spaceReplacer);
}

export function checkWebglSupport() {
	if (!window.WebGLRenderingContext) return false;
	try {
		var _canvas = document.createElement('canvas');
		var _gl = _canvas.getContext('webgl') || _canvas.getContext('experimental-webgl');
		_gl.clearStencil(0);
		var errors = _gl.getError();
		return errors == 0;
	} catch (e) {
		return false;
	}
}

/**
 * get dimensions from a fileobject
 * @param file object
 * @returns {{width: number, height: number, x: number, y: number}|*}
 */
export const getDimensions = (() => {
	let store = {};
	return ({metaData,path,imageMaxWidth,imageMaxHeight}, raw) => {
		// var re = /-(\d+)-(\d+)-(\d+)-(\d+).[jpeng]{3,4}/g,
		// 	match = re.exec(filename),
		var	width = 0,
			height = 0,
			x = 0,
			y = 0,
			containerWidth = $("#configurator-viewers").outerWidth(),
			containerHeight = $("#configurator-viewers").outerHeight(),
			widthPercentage = containerWidth / imageMaxWidth,
			heightPercentage = containerHeight / imageMaxHeight,
			// choose the smaller percentage to make sure truck fits
			percentage = heightPercentage < widthPercentage ? heightPercentage : widthPercentage,
			normalizedPath = path ? path.split('images/region/').slice(-1)[0].split('.png')[0] : 'data:';

		if(normalizedPath.indexOf('data:') !== -1){
			return {
				width,
				height,
				x,
				y,
				percentage
			};
		}
		
		if (metaData) {
			store[normalizedPath] = metaData;
		}
		else if(store[normalizedPath]) {
			metaData = store[normalizedPath];
		}
		else {
			console.log('META NOT FOUND',normalizedPath,store);
		}

		if (metaData) {
			width = raw ? Math.round(metaData.w) : Math.round(metaData.w * percentage);
			height = raw ? Math.round(metaData.h) : Math.round(metaData.h * percentage);
			x = raw ? Math.round(metaData.x) : Math.round(metaData.x * percentage);
			y = raw ? Math.round(metaData.y) : Math.round(metaData.y * percentage);
		}

		return {
			width,
			height,
			x,
			y,
			percentage
		};
	};
})();

export function checkGyroSupport() {
	return new Promise((resolve, reject) => {
		if (window.DeviceMotionEvent) {
			window.addEventListener("devicemotion", function (event) {
				if (event.rotationRate.alpha || event.rotationRate.beta || event.rotationRate.gamma) {
					resolve(true);
				} else {
					resolve(false);
				}
			});
			// FF claims window.DeviceMotionEvent - but the event never fires on desktop
			setTimeout(() => {
				resolve(false);
			}, 300);
		} else {
			resolve(false);
		}
	}).then(b => {
		return b;
	});
}


// export async function checkGyroSupport() {
// 	try {
// 		let support = await testGyroSupport();
// 		return support;
// 	} catch (err) {
// 		console.log(err);
// 		return false;
// 	}
// }

export function getOptionsMatrixRegionId(){
	return  window.regionId || '1';
}

export function getCulture(){
	return  window.culture || 'en-us';
}

export function getUiCopy(){
	return window.uiCopy || {};
}

export function getRegionDir(){
	return ({
		'1':'en-US', // en-us
		'2':'es-MX', //es-mx
		'3':'es-MX', //es-cl
		'4':'es-MX', //es-co
		'5':'es-MX', //es-pe
		'6':'super-t',
		'7': 'en-US',
		'8': 'en-US'
	})[getOptionsMatrixRegionId()];
}

export function getOptionsMatrix() {
	// get options matrix and update store

	return new Promise(function(resolve, reject) {
		let OptionsMatrixRegionId = getOptionsMatrixRegionId(),
			url = getEnvironment() === "DEV"
				? `https://freightlinertrucks-dev.azurewebsites.net/umbraco/Api/configuratorMapping?regionId=${OptionsMatrixRegionId}`
				: `/umbraco/Api/ConfiguratorMapping?regionId=${OptionsMatrixRegionId}`;
		
		$.ajax({
			url
		}).done(function(response) {
			
			// let data = getEnvironment() === "DEV" ? response : JSON.parse(response.Json),
			let data = JSON.parse(response.json),
				optionsMatrix = _.mapValues(_.groupBy(data, "Mode (Web)"), function (mode) {
					return _.mapValues(_.groupBy(mode, "Component"), function (component) {
						return component;
					});
				});
			resolve(optionsMatrix);
		}).fail(function (e) {
			console.log("failed to get options matrix", e);
			reject("failed to get options matrix", e);
		});
	});
}

function currentDate(){
	let date = new Date();
	return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
}

export function imgixRequest({path, options}){
	let { mediaHostAddress = 'https://ftl.imgix.net', cacheImgBust = currentDate() } = window;
	options.bust = cacheImgBust;
	return mediaHostAddress + '/' + path + '?' + Object.keys(options).map( key => {
		let value = options[key],
			type = typeof value;
		return type === 'string' || type === 'number' ?
				`${key}=${value}` :
			type === 'object' ? 
				Array.isArray(value) ?
					`${key}=${value.join(encodeURIComponent(','))}` :
					`${key}64=${encodeURI(btoa(imgixRequest(value))).replace('/','_')}` :
			'';
	}).filter( value => value !== '' ).join('&');
}

function getValueFromBuildState({state,typeLookup,lookInValues = false}){
	let [type,lookupCondition] = typeLookup.split(':'),
		[lookup, condition] = lookupCondition.split('='),
		settings = state[type + 'BuildSettings'];

	return settings ? 
		lookInValues ? 
			_.values(settings).indexOf(lookup) !== -1 ? 
				lookup : false :
			condition ? 
				settings[lookup] === condition ?
					condition : false :
				settings[lookup] || false :
		false;
}

export function conditionalValue({state,standard,conditions={}}){
	let [action, typeLookup] = conditions[standard] || conditions['*'] || ['skip',''];
	
	return standard || action === 'temp' ? ({
		get_val(){
			let value = getValueFromBuildState({state,typeLookup})
			if(value){
				return `${standard}-${value}`;
			}
		},
		if_val(){
			let value = getValueFromBuildState({state,typeLookup,lookInValues:true});
			if(value){
				return `${standard}-${value}`;
			}
		},
		temp(){
			return typeLookup.split('{').map( itemPart => {
				let [lookup, append] = itemPart.split('}');
				return itemPart.indexOf('}') !== -1 ?
					(lookup === 'SELF' ? standard : getValueFromBuildState({state,typeLookup:lookup}) || '') + append :
					itemPart;
			}).join('');
		},
		skip(){}
	})[action]() || standard : false;
}

export function getDefaultOption(state, categories, categoryRules) {
	let truckName = state.truckModel + " " + state.truckCab,
		defaultOption = _.chain(categories).map(category => {
			return category;
		}).flatten().find(option => {
			return option[truckName] === "*";
		}).value(),
		defaultOptionValue = false;
	//console.log('TRUCK',truckName);
	// pipe the category rules in here so that the return of defaultOptions can be category name
	if (defaultOption && _.includes(categoryRules, defaultOption.Component)) {
		defaultOptionValue = defaultOption.Category;
	} else if (defaultOption) {
		defaultOptionValue = defaultOption.Key;
	}
	// console.log("default options", defaultOptionValue, defaultOption, categories, categoryRules);
	return defaultOptionValue;
}

/**
 * check for incompatibility of an option against buildsettings
 * @param option
 * @param buildSettings
 * @returns {boolean}
 */
export function optionIsIncompatible(option, buildSettings) {
	// if(option.Component.indexOf('Fairing') !== -1){
	// 	console.log('CHECK INC',{option, buildSettings},_.some(_.map(option.Incompatibilities.split(";"), function (inc) {
	// 		// empty incompatibility matches anything so make sure it is not empty
	// 		return inc !== "" && _.includes(buildSettings, inc);
	// 	}), Boolean));
	// }
	
	return _.some(_.map(option.Incompatibilities.split(";"), function (inc) {
		// empty incompatibility matches anything so make sure it is not empty
		return inc !== "" && _.includes(buildSettings, inc);
	}), Boolean);
}

export function getFile(url, method) {
	// get image mapping file for Interior viewer and update store
	let p = new Promise(function (resolve, reject) {
		$.ajax({
			url: url,
			method: method ? method : "GET"
		}).done(function (map) {
			resolve(map);
		}).fail(function (e) {
			reject(`failed to get ${url} with error: ${JSON.stringify(e)}`);
		});
	});
	return p;
}

export function postData(url) {
	// post something to a url with query params
	let p = new Promise(function (resolve, reject) {
		$.ajax({
			url: url,
			method: "POST"
		}).done(function (response) {
			resolve(response);
		}).fail(function (e) {
			reject(`failed to post data to ${url} with error: ${JSON.stringify(e)}`);
		});
	});
	return p;
}

export function isMobile() {
	let mobile = new MobileDetect(window.navigator.userAgent);
	return !!(mobile.mobile() || mobile.tablet());
}

export function getNumFrames(isMobile) {
	return isMobile ? 8 : 12;
}

export function getShareLayers(layers, i) {
	let isMobile = isMobileDevice();
	let state = store.getState(),
		filledLayers = _.filter(layers, layer => $(layer).children().length > 0);
	
	return Rx.Observable.from(filledLayers)
		.mergeMap((layer, layerOrder) => {
			let frames,
				index;
			
			switch (layer.className) {
				case "image-layer":
				case "paint-layer": {
					frames = $(layer).find("img");
					index = i !== undefined ? i : angleToIndex(state.socialShareAngle, frames.length);
					let img = $(layer).find("img").eq(index),
						src = img.attr("src");					
					return getImage(src, layerOrder);
				}
				// frames = $(layer).find("canvas");
				// index = i !== undefined ? i : angleToIndex(state.socialShareAngle, frames.length);
				// return getCanvas($(layer).find("canvas").eq(index)[0], isMobile)
			}
			return Rx.Observable.of(false);
		})
		.filter(layer => {
			return layer;
		}).bufferCount(filledLayers.length);
}

export function createShareImage(imageData, type = "jpeg") {
	let canvas, context,
		imgBase64,
		desktopWidth = 1365,
		desktopHeight = 910,
		targetScale;
	let isMobile = isMobileDevice();
	console.log("share image data:", imageData);
	canvas = document.createElement("canvas");
	canvas.width = isMobile ? 680 : desktopWidth;
	canvas.height = isMobile ? 453 : desktopHeight;
	targetScale = Math.min(desktopWidth / canvas.width, desktopHeight / canvas.height) * (isMobile ? 0.9 : 1);
	context = canvas.getContext("2d");
	if (type === "jpeg" || type === "jpg") {
		type = "jpeg";
		context.globalCompositeOperation = "source-over";
		context.fillStyle = "#ffffff";
		context.fillRect(0, 0, canvas.width, canvas.height);
	}
	context.fillStyle = "#e9e9e9";
	context.fillRect(0, 0, canvas.width, canvas.height);
	imageData.forEach(imgData => {
		context.drawImage(imgData.img, 0, 0,
			imgData.dims.width, imgData.dims.height,
			imgData.dims.x * targetScale, imgData.dims.y * targetScale,
			imgData.dims.width * targetScale, imgData.dims.height * targetScale);
	});
	imgBase64 = canvas.toDataURL(`image/${type}`, 0.9).replace(/data:image\/[jpeng]{3,4};base64,/, "");
	//console.log(imgBase64);
	return Rx.Observable.of(imgBase64);
}

export function uploadShareImage(ImgBase64, token) {
	
	let state = store.getState();

	let BuildSettings = JSON.stringify(
		Object.assign({},
			state.exteriorBuildSettings,
			state.interiorBuildSettings,
			state.miscBuildSettings,
			{
				truckModel: state.truckModel,
				cabType: state.cabType,
				truckCab: state.truckCab,
				optionInteracted: state.optionInteracted,
				numFrames: getNumFrames(isMobileDevice())
			},
		));

	let Hash = objectHash(BuildSettings);

	let env = getEnvironment();

	return Rx.Observable.of(ImgBase64).mergeMap(() => {
		let payload = {
			ImgBase64,
			Hash,
			BuildSettings
		};
		
		return new Promise((resolve, reject) => {
			$.ajax({
				headers: token,
				type: "POST",
				// post to endpoint based on environment
				url: env === "DEV"
					? "https://freightlinertrucks-dev.azurewebsites.net/umbraco/Api/ConfiguratorShare"
					: "/umbraco/Api/ConfiguratorShare",
				contentType: env === "DEV"
					? "application/x-www-form-urlencoded; charset=UTF-8"
					: "application/json; charset=utf-8",
				data: env === "DEV"
					? payload
					: JSON.stringify(payload)
			})
				.done(r => resolve({
					r,
					hash: Hash
				}))
				.fail(e => {
					reject(e);
				});
		});
	});
}

function getOptionName(option) {
	return option["Option Override (Web)"] || (option.Option.toLowerCase().includes("not equipped") ? "None" : option.Option);
}

/**
 * Builds the data used to display the UI for selecting truck options
 * @param state
 * @param options - the available options from the options matrix
 * @param buildSettings
 * @returns {*}
 */
function generateBuilderOptionGroups({state, options, buildSettings, combinedBuildSettings}) {
	// nothing to build yet we don't have a truck
	if (state.truckCab === "") {
		return [];
	}
	
	return _.chain(options).map((group, groupKey) => {
		let currentOption = "";
		let currentOptionKey = "";
		let optionGroup;

		// use state.altWorkflows here to define altworkflow
		// then pass that all down the chain
		let altWorkflow = state.altWorkflows[groupKey];
		//console.log('group option',_.at(group,'[0]["Component"]'),_.at(group,'[0]["Grouping (Web)"]'));
		//let altWorkflow = _.isArray(group) && group[0] && group[0]['Component'] && group[0]['Grouping (Web)'] && state.altWorkflows[group[0]['Component']] ? group[0]['Grouping (Web)'] : false;

		if (groupKey === "Cab") {
			return false;
		}

		if (_.isArray(group)) {
			// list of components
			optionGroup = _.chain(group).map(option => {

				let attributes = {
						"type": "radio",
						"name": option.Component,
						"autocomplete": "off",
						"data-name": option.Option,
						"data-incompatibilities": option.Incompatibilities,
						"data-key": option.Key,
						"data-category": option["Grouping (Web)"],
						"data-component": option.Component,
					},
					activeBtn = option.Key === buildSettings[option.Component],
					// check if option is incompatible with any of the build settings
					disabledBtn = optionIsIncompatible(option, combinedBuildSettings);


				if (option.Component === 'Color') {
					attributes.color = option.Data;
				}

				if (activeBtn && !disabledBtn) {
					attributes.checked = "checked";
					currentOption = getOptionName(option);
					currentOptionKey = option.Key;
				}


				if (disabledBtn) {
					attributes.disabled = "disabled";
				}
				if (option[state.truckModel + " " + state.truckCab] !== "" && !disabledBtn) {

					return {
						label: getOptionName(option),
						attributes: attributes
					};

				}
				return false;
			}).compact().flatten().value();
		} else {
			// group of components
			optionGroup = _.chain(group).mapValues((component, componentKey) => {
				currentOption = '';
				currentOptionKey = '';
				let options = _.chain(component).map(option => {
					let attributes = {
							"type": "radio",
							"name": option.Component,
							"autocomplete": "off",
							"data-name": option.Option,
							"data-incompatibilities": option.Incompatibilities,
							"data-key": option.Key,
							"data-category": option.Category,
							"data-component": option.Component
						},
						activeBtn = option.Key === buildSettings[option.Component],
						// check if option is incompatible with any of the build settings
						disabledBtn = optionIsIncompatible(option, combinedBuildSettings);


					if (option.Component === 'Color') {
						attributes.color = option.Data;
					}

					if (activeBtn && !disabledBtn) {
						attributes.checked = "checked";
						currentOption = getOptionName(option);
						currentOptionKey = option.Key;
					}

					if (disabledBtn) {
						attributes.disabled = "disabled";
					}
					if (option[state.truckModel + " " + state.truckCab] !== "" && !disabledBtn) {

						return {
							option: option,
							label: getOptionName(option),
							component: option.Component,
							current: currentOption,
							attributes: attributes,
							altWorkflow
						};
					}
					return false;
				}).compact().value();
				if (currentOption === '' & options.length > 0) {
					options[0].attributes.checked = "checked";
					currentOption = getOptionName(options[0].option);
					currentOptionKey = options[0].option.Key;
				}
				return options.length > 0
					? {
						options,
						current: currentOption,
						label: componentKey,
						parent: groupKey,
						group: altWorkflow ? false : groupKey,
						groupLabel: _.at(options,'[0]["option"]["Label (Web)"]')[0],
						altWorkflow
					}
					: false;
			}).value();
		}

		if(!Array.isArray(optionGroup) && Object.values(optionGroup).filter( item => item ).length === 0){
			return false;
		}

		if ((optionGroup.length === 1 && optionGroup[0].label !== "None") || optionGroup.length > 1 || _.isPlainObject(optionGroup)) {
			let children = altWorkflow ? _.chain(optionGroup).map(component => {
				return component && (component.options
					? component.options
					: component);
			}).flatten().compact().value() : [];
			return {
				label: groupKey,
				// card: cards[componentKey],
				current: currentOption,
				currentKey: currentOptionKey,
				options: optionGroup,
				group: altWorkflow ? false : groupKey,
				groupLabel: _.at(optionGroup,'[0]["option"]["Label (Web)"]')[0],
				altWorkflow,
				parent: (group[0] || {}).Component || groupKey,
				children: children
			};
		}
		return false;
	})
	// 	.compact().concat([{
	// 	// Add blank item to allow flushing of group if no other options come after.
	// }]).reduce((cur, option) => {
	// 	// Flush any current group that is complete
	// 	if (option.group !== cur.group.name && cur.group.options.length > 0) {
	// 		// console.log(cur.group.options);
	// 		cur.result.push({
	// 			label: cur.group.name,
	// 			options: cur.group.options,
	// 			current: cur.group.options.map(opt => {
	// 				return opt.current;
	// 			}).join(' / ')
	// 		});
	// 		cur.group = {
	// 			name: undefined,
	// 			options: []
	// 		};
	// 	}
	//
	// 	_.chain(cur.awaitingParent).groupBy(item => {
	// 		if (item.parent === option.label) {
	// 			//item.parentOption = option;
	// 			return 'child';
	// 		}
	// 		return 'orphan';
	// 	}).map((list, key) => {
	// 		switch (key) {
	// 			case 'child':
	// 				option.children.concat(list);
	// 				break;
	// 			case 'orphan':
	// 				cur.awaitingParent = list;
	// 		}
	// 	});
	//
	// 	if (option.group === undefined) {
	// 		// option.options.forEach(item => {
	// 		// 	item.option = option;
	// 		// });
	// 		if (option.parent === undefined) {
	// 			cur.result.push(option);
	// 		}
	// 		else {
	// 			let parent = cur.result.find(item => item.label === option.parent);
	// 			if (parent) {
	// 				//option.parentOption = parent;
	// 				parent.children.push(option);
	// 			}
	// 			else {
	// 				cur.awaitingParent.push(option);
	// 			}
	// 		}
	// 	}
	// 	else {
	// 		cur.group.name = option.group;
	// 		cur.group.options.push(option);
	// 	}
	// 	return cur;
	// }, {
	// 	group: {
	// 		name: undefined,
	// 		options: []
	// 	},
	// 	awaitingParent: [],
	// 	result: []
	// }).reduce((cur, value) => {
	// 	return cur.concat(value.options || value);
	// }, [])
		.flatten().value();
}

function getCategoryInfo(state, componentKey) {
	return state.componentInfo[componentKey] ?
		h("div.category-info", state.componentInfo[componentKey]) : "";
}

export function getBuildSettingsAndOptions(state, viewOption) {
	let options;
	let buildSettings,
		{exteriorBuildSettings, interiorBuildSettings, miscBuildSettings, groupedOptionsMatrix} = state;
	switch (viewOption || state.viewOption) {
		case "Exterior":
			buildSettings = exteriorBuildSettings;
			options = groupedOptionsMatrix.Exterior;
			break;
		case "Interior":
			buildSettings = interiorBuildSettings;
			options = groupedOptionsMatrix.Interior;
			break;
		case "Powertrain & Safety":
			buildSettings = miscBuildSettings;
			options = groupedOptionsMatrix["Powertrain + Safety + Connectivity"];
			break;
	}
	return {
		options,
		buildSettings,
		combinedBuildSettings: Object.assign({},exteriorBuildSettings,interiorBuildSettings,miscBuildSettings)
	};
}

export function generateBuilderUI(state, viewOption) {
	let { options, buildSettings, combinedBuildSettings } = getBuildSettingsAndOptions(state, viewOption);
	
	return generateBuilderOptionGroups({state, options, buildSettings, combinedBuildSettings});
}

/**
 * update buildsettings with incompatibilities
 * @param buildSettings
 * @param state
 * @param components
 * @returns {*}
 */
export function processIncompatibilities({buildSettings, combinedBuildSettings = {}, state, components}) {
	// update buildSettings with incompatibilities
	combinedBuildSettings = {...combinedBuildSettings, ...buildSettings};
	return _.chain(buildSettings).mapValues((value, setting) => {
		let incompatible = _.chain(components[setting])
			.filter(option => option.Key === value)
			
			.some(option => optionIsIncompatible(option, combinedBuildSettings))
			.value();
		if (incompatible) {
			// find the first compatible option if any
			let firstCompatible = _.find(components[setting], option => {
				let truck = `${state.truckModel} ${state.truckCab}`;
				return !optionIsIncompatible(option, combinedBuildSettings)
					&& option[truck] !== "";
			});
			return (firstCompatible || {Key: false}).Key;
		}
		return value;
	}).value();
}

export function getBuildChanges(component, key) {
	let state = store.getState();
	let { options, buildSettings, combinedBuildSettings } = getBuildSettingsAndOptions(state);
	let components;

	switch (state.viewOption) {
		case "Exterior":
			components = state.optionsMatrix.Exterior;
			break;
		case "Interior":
			components = state.optionsMatrix.Interior;
			break;
		default:
			components = state.optionsMatrix["Powertrain + Safety + Connectivity"];
	}

	// update the buildsettings with the new option
	buildSettings[component] = key; // $target.attr("data-component") $target.attr("data-key")

	// check for incompatibilities with other components
	buildSettings = processIncompatibilities({buildSettings, state, components, combinedBuildSettings});


	console.log("CHECK INC updated build settings", JSON.parse(JSON.stringify(buildSettings)) , combinedBuildSettings);

	if (state.viewOption === "Powertrain & Safety") {
		return {
			type: ACTIONS.MISC_BUILD_CHANGE,
			buildSettings
		};
	} else if (state.view === "interior") {
		return {
			type: ACTIONS.INTERIOR_BUILD_CHANGE,
			buildSettings,
			exteriorBuildSettings: processIncompatibilities({...getBuildSettingsAndOptions(state,'Exterior'), state, components: state.optionsMatrix.Exterior})
		};
	} else if (state.view === "exterior") {
		return {
			type: ACTIONS.EXTERIOR_BUILD_CHANGE,
			buildSettings
		};
	}
}

export function getFabs(uiState, all) {
	let fabData, fabs,
		truckName = "New Cascadia-" + uiState.truckCab;
	// get the id of the current pillar for the current truck
	if (!uiState.truckCab || !uiState.pathTree || !uiState.pathTree.FTL.Truck[truckName].Explore[_.capitalize(uiState.view)]) {
		return [];
	}

	if (all) {
		// get all the fab ids for the truck regardless of pillar
		fabData = _.chain(uiState.pathTree)
			.deepPluck("FTL.Truck." + truckName + ".Explore." + _.capitalize(uiState.view))
			.map((pillar, pillarKey) => {
				return _.chain(pillar).map((xNode, key) => {
					let x = parseInt(key, 10);
					return _.chain(xNode).map((yNode, key) => {
						return {
							"pillar": pillarKey,
							"id": yNode.id,
							"fabPosition": {
								radius: uiState.interiorViewRadius,
								// lat/phi -90 to 90
								lat: x,
								// lon/theta -180 to 180
								lon: parseFloat(key, 10)
							}
						};
					}).flatten().value();
				}).flatten().value();
			}).flatten().value();
	} else {
		// get all the fab ids filtered by truck and current pillar
		fabData = _.chain(uiState.pathTree)
			.deepPluck("FTL.Truck." + truckName + ".Explore." + _.capitalize(uiState.view) + "." + uiState.pillar)
			.map((xNode, key) => {
				let x = parseInt(key, 10);
				return _.chain(xNode).map((yNode, key) => {
					if (uiState.view === "exterior") {
						return {
							"pillar": uiState.pillar,
							"id": yNode.id,
							"fabPosition": {
								x: x,
								y: parseInt(key, 10)
							}
						};
					}
					return {
						"pillar": uiState.pillar,
						"id": yNode.id,
						"fabPosition": {
							radius: uiState.interiorViewRadius,
							// lat/phi -90 to 90
							lat: x,
							// lon/theta -180 to 180
							lon: parseFloat(key, 10)
						}
					};
				}).flatten().value();
			}).flatten().value();
	}
	// console.log(fabData, _.deepPluck(state.pathTree, "FTL.Truck." + truckName + ".Explore.Exterior." + state.pillar));

	// filter the fabs by the ids gathered above
	fabs = _.chain(uiState.adsFabs).filter((fab) => {
		return _.some(fabData, fabInfo => {
			return _.includes(fab.nodes, fabInfo.id);
		});
	})
	// combine the fabs with the info gathered above
		.map((fab, i) => {
			let fabInfo = _.chain(fabData).filter(fabInfo => {
					return _.includes(fab.nodes, fabInfo.id);
				}).value()[0],
				additionalData = {
					fabPosition: fabInfo.fabPosition,
					pillar: fabInfo.pillar,
					index: i,
					assets: false
				},
				assetNode = _.chain(uiState.pathTree)
					.deepPluck("FTL.Asset." + fab.id).value(),
				assetNodeId = assetNode && assetNode.id,
				// combine the fab with other assets like videos
				assets = _.chain(uiState.adsVids).filter(vid => {
					return _.includes(vid.nodes, assetNodeId);
				}).value();

			if (assets.length > 0) {
				additionalData.assets = assets;
			}

			return Object.assign({}, fab, additionalData);
		}).value();
	// console.log("fabs", fabs);
	return fabs;
}

export function getHashParameter(parameterName) {
	var hash = window.location.hash,
		re = new RegExp("[#&]" + parameterName + "=([\\w-]+)", "gi"),
		parameter = re.exec(hash) || [null, ''];
	return parameter[1];
}

export function getUrlParams(url) {
	var re = /(?:\#|&(?:amp;)?)([^=&#]+)(?:=?([^&#]*))/g,
		match, params = {},
		decode = function (s) {
			return decodeURIComponent(s.replace(/\+/g, " "));
		};

	if (typeof url == "undefined") url = document.location.href;

	while (match = re.exec(url)) {
		params[decode(match[1])] = decode(match[2]);
	}
	return params;
}

export function getParameterByName(name, url) {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function qp() {
	return window.location.search.substr(1).split('&').reduce((a, c) => Object.assign(a, c.split('=').reduce((a, c) => ({ [a]: c }))), {});
}


/**
 * pass in object of parameters key: value
 * @param params
 */
export function updateHashParameters(params) {
	if (!params) {
		window.location.hash = "";
	} else if (_.isObject(params)) {
		let currentParams = getUrlParams(),
			newParams = Object.assign({}, currentParams, params);
		// only return params that have values
		window.location.hash = _.chain(newParams).omitBy(v => !v).map((v, k) => k + "=" + v.replace(" ", "_")).value().join("&");
	}
}

export function stateInit({view,pillar,nav:mode}) {
	return {
		standalone: $("#standalone-configurator").length > 0,
		truck: '',
		view,
		pillar,
		mode
	};
}

export function deepLink(state) {
	let truck = getHashParameter("truck"),
		view = getHashParameter("view"),
		pillar = getHashParameter("pillar"),
		mode = getHashParameter("mode"),
		standalone = $("#standalone-configurator").length > 0;

	if (!deepLinkMap[truck]) {
		truck = "";
		updateHashParameters();
	}
	if (!_.includes(state.views, view)) {
		view = state.view;
		updateHashParameters({ "view": false });
	}
	if (!_.includes(state.pillars.map(p => p.name), pillar)) {
		pillar = state.pillar;
		updateHashParameters({ "pillar": false });
	}
	if (!_.includes(state.navs, mode)) {
		mode = state.nav;
	}
	// console.log({
	// 	standalone,
	// 	truck,
	// 	view,
	// 	pillar,
	// 	mode
	// });
	return {
		standalone,
		truck,
		view,
		pillar,
		mode
	};
}

/**
 * get dimensions from a filename
 * @param filename
 * @returns {{width: number, height: number, x: number, y: number}|*}
 */
// export function getDimensions(filename) {
// 	var re = /-(\d+)-(\d+)-(\d+)-(\d+)\.[jpeng]{3,4}/g,
// 		match = re.exec(filename),
// 		width = 0,
// 		height = 0,
// 		x = 0,
// 		y = 0,
// 		dims;

// 	if (match) {
// 		width = parseInt(match[1], 10);
// 		height = parseInt(match[2], 10);
// 		x = parseInt(match[3], 10);
// 		y = parseInt(match[4], 10);
// 	}
// 	dims = {
// 		width: width,
// 		height: height,
// 		x: x,
// 		y: y,
// 	};
// 	return dims;
// }

/**
 * get image data and dims
 * @param src
 * @returns {Promise}
 */
export function getImage(src, layerOrder, raw) {
	
	let p = new Promise((resolve, reject) => {
		var img = new Image(),
			dims;
		img.setAttribute('crossOrigin', 'anonymous');
		img.src = src;
		dims = isMobileDevice() && !raw ? getDimensions({path:src,imageMaxWidth:1365,imageMaxHeight:910}) : getDimensions({path:src},true);;

		if(!src || src.indexOf('data:') !== -1){
			return resolve({
				src,
				img,
				dims,
				layerOrder
			});
		}
		
		img.onload = function () {
			resolve({
				src,
				img,
				dims,
				layerOrder
			});
		};
		img.onerror = (e) => {
			if (window.dataLayer) {
				window.dataLayer.push({
					event: "configurator_get_image_error",
					data: {
						src,
						dims,
						layerOrder
					}
				});
			}
			resolve(false);
		};
	});
	return p;
}

export function angleToIndex(angle, numFrames) {
	return (angle / 360) * numFrames >> 0;
}

export function htmlDecode(input) {
	var doc = new DOMParser().parseFromString(input, "text/html");
	return doc.documentElement.textContent;
}


export function encode_utf8(s) {
	return unescape(encodeURIComponent(s));
}

export function decode_utf8(s) {
	return decodeURIComponent(escape(s));
}

// ucs-2 string to base64 encoded ascii
export function encodeBase64(str) {
	return window.btoa(encode_utf8(str));
}

// base64 encoded ascii to ucs-2 string
export function decodeBase64(str) {
	return decode_utf8(window.atob(str));
}

function sortObject(o) {
	return Object.keys(o).sort().reduce((r, k) => (r[k] = o[k], r), {});
}

export function getCanvas(canvas, isMobile) {
	let src = canvas.getAttribute("data-image-src"),
		p = new Promise((resolve, reject) => {
			resolve({
				src,
				img: canvas,
				dims: {
					width: isMobile ? 680 : 1365,
					height: isMobile ? 453 : 910,
					x: 0,
					y: 0
				}
			});
		});
	return p;
}

export function testCanvasOverlayBlendMode() {
	let c = document.createElement('canvas');
	let ctx = c.getContext('2d');
	ctx.globalCompositeOperation = "overlay";
	return ctx.globalCompositeOperation === "overlay";
}

export function leadFormData(){
	return window.formData || false;
}

/**
 * returns an environment string: "DEV" or "STAGING" or "PROD"
 * @returns {string}
 */
export function getEnvironment() {
	let { environment } = window;
	if (environment && environment !== '') {
		return environment;
	}

	var host = window.location.hostname;
    if (host.indexOf("freightlinertrucks.com") !== -1
        || host.indexOf("freightliner.com") !== -1
        || host.indexOf("freightlinertrucks.azurewebsites.net") !== -1) {
        return "PROD";
    } else if (host.indexOf("freightlinertrucks-dev.azurewebsites.net") !== -1
        || host.indexOf("freightlinertrucks-staging.azurewebsites.net") !== -1) {
        return "STAGING";  
	} else {
		return "DEV";
	}
}

// element-closest | CC0-1.0 | github.com/jonathantneal/closest
if (typeof Element.prototype.matches !== 'function') {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.webkitMatchesSelector || function matches(selector) {
		var element = this;
		var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
		var index = 0;

		while (elements[index] && elements[index] !== element) {
			++index;
		}

		return Boolean(elements[index]);
	};
}
if (typeof Element.prototype.closest !== 'function') {
	Element.prototype.closest = function closest(selector) {
		var element = this;

		while (element && element.nodeType === 1) {
			if (element.matches(selector)) {
				return element;
			}

			element = element.parentNode;
		}

		return null;
	};
}
// end element-closest polyfill